export class NotificationSettings {
  comtype: string;
  comTypesParsed: NotificationSettingsComType[];
  notification_description: string;
  notification_type: string;
  person_id: number;
}

export class NotificationSettingsComType {
  notification_type_id: number;
  comms_type_id: number;
  comms_type: string;
  select: number;
}

export class NotificationSettingsComTypeHeader {
  comms_type_id: number;
  comms_type: string;
}

export class SaveNotificationSettings {
  PersonId: number;
  NotificationTypeId: number;
  CommsTypeId: number;
  isSelected: number;
}
